"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CheckFilled = function CheckFilled(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.4 6H3.605A1.607 1.607 0 002 7.605V16.4A1.607 1.607 0 003.605 18H20.4a1.607 1.607 0 001.6-1.6V7.605A1.607 1.607 0 0020.4 6zM5.5 9h5a.5.5 0 010 1h-5a.5.5 0 010-1zm0 2h5a.5.5 0 010 1h-5a.5.5 0 010-1zm8 4h-8a.5.5 0 010-1h8a.5.5 0 010 1zm4.818-.21a2.011 2.011 0 01-.318.1v.61a.5.5 0 01-1 0v-.6a2.481 2.481 0 01-1.251-.651.5.5 0 01.7-.711 1.444 1.444 0 001.481.331.758.758 0 00.467-.773c0-.407-.3-.583-.989-.887-.618-.273-1.463-.647-1.463-1.607a1.552 1.552 0 01.98-1.419c.024-.01.048-.009.072-.017V8.5a.5.5 0 011 0v.608a1.961 1.961 0 01.9.512.5.5 0 11-.7.711.786.786 0 00-.885-.227.557.557 0 00-.365.5c0 .264.217.4.867.692.669.3 1.585.7 1.585 1.8a1.744 1.744 0 01-1.081 1.694z",
    fill: "currentColor"
  })));
};

var _default = CheckFilled;
exports["default"] = _default;